import React from 'react'
import { css } from '@emotion/core'
import { createSelfCheckinBaseStyle, createSelfCheckinResponsiveStyle } from '@/utils/front-tablet-responsive-style'

type ErrorMessageProps = {
  children: React.ReactNode
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ children }) => {
  return <div css={errorMessageStyle}>{children}</div>
}

const errorMessageStyle = css(
  {
    fontSize: 14,
    fontWeight: 'bold',
    marginTop: 16,
    textAlign: 'left',
    color: '#FF2700',
  },
  createSelfCheckinBaseStyle({ fontSize: 16 }),
  createSelfCheckinResponsiveStyle({ landscape13: { fontSize: 20 } }),
)
